const handleTranslations = (state) => {
  // state.forms.validationMessages = translations.validationMessages
  // state.forms.errors = translations.errors
  state.translationsLoaded = true
}

const setWebP = (state, { result }) => {
  state.webp = result
  state.webpRendered = true
}

const setLanguage = (state, { lang }) => {
  state.language = lang
}

// Export
export default {
  handleTranslations,
  setWebP,
  setLanguage
}
